<template>
    <div
        v-if="options.HighlightContent"
        :class="highlightClass"
    >
        <div class="columns small-12 medium-10">
            <div
                class="text-with-border"
                data-test-content
            >
                <generic-content-title
                    v-if="options.ShowTitle"
                    :is-heading-h2="options.IsTitleContainerH2"
                    :title="options.Title"
                />
                <div
                    v-if="options.ShowText"
                    class="padding-bottom"
                    data-test-content-text
                    v-html="options.Text"
                />
                <generic-content-button
                    v-if="options.ShowButton"
                    :options="options.Button"
                    :is-highlighted="options.HighlightContent"
                />
            </div>
        </div>
    </div>
    <div
        v-else
        :class="highlightClass"
        data-test-content
    >
        <generic-content-title
            v-if="options.ShowTitle"
            :is-heading-h2="options.IsTitleContainerH2"
            :title="options.Title"
        />
        <div
            v-if="options.ShowText"
            class="padding-bottom"
            data-test-content-text
            v-html="options.Text"
        />
        <generic-content-button
            v-if="options.ShowButton"
            :options="options.Button"
            :is-highlighted="options.HighlightContent"
        />
    </div>
</template>

<script>
import GenericContentButton from './GenericContentButton.vue';
import GenericContentTitle from './GenericContentTitle.vue';

export default {
    name: 'GenericContent',
    components: {
        GenericContentTitle,
        GenericContentButton
    },
    props: {
        options: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    computed: {
        highlightClass() {
            return this.options.HighlightContent ? 'push-down row' : 'push-down';
        }
    }
};
</script>
